import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService {
  private spinnerSubject = new Subject<boolean>();
  spinnerState$ = this.spinnerSubject.asObservable();
  constructor(private spinner: NgxSpinnerService) { }
  show() {
    ("spinner show");
    this.spinnerSubject.next(true);
    this.spinner.show();
  }
  hide() {
    this.spinnerSubject.next(false);
    this.spinner.hide();
  }

}
